<form
  *ngIf="
    orderProcessFG &&
    !isInstallationFlow &&
    (showSection(sectionType.Offer) || showSection(sectionType.Order) || showSection(sectionType.Invoice) || showDownloadOfferSection)
  "
  [formGroup]="orderProcessFG"
  class="order-process-container component-container">
  <div class="margin-align">
    <div class="margin-header-align text-uppercase page-title">{{ 'overview.process-details.order-process-title' | translate }}</div>
  </div>

  <div class="standard-offer-row ui-g-12 form-font-size" *ngIf="showDownloadOfferSection">
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section" *ngIf="!showApplicationIdInOffer">
      <div class="ui-g-6 field-label">{{ 'overview.process-details.standard-offer-title' | translate }}</div>
    </div>
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section" *ngIf="showApplicationIdInOffer">
      <input class="doc-submit-inputs" [value]="standardOfferApplicationIdTitle" [disabled]="true" pInputText type="text" />
    </div>

    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 action-button-section">
      <button
        (click)="downloadDocument(offerData.document[0])"
        [disabled]="disableOffer"
        class="view-btn-width"
        id="standard-offer-download-btn"
        label="{{ 'view-button-label' | translate }}"
        pButton
        type="button"></button>
    </div>

    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section" *ngIf="showOrderOfferText">
      {{ 'overview.process-details.standard-offer-info' | translate }}
    </div>
  </div>

  <div *ngIf="!isReadOnly && isInternalUser" class="file-upload-section form-font-size">
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
      <input class="doc-submit-inputs" formControlName="standardOfferDocument" pInputText type="text" />
    </div>
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
      <p-fileUpload
        #documentUploader
        (onSelect)="
          uploadDocument($event.files[0], docIdTypes.offer, documentUploader, orderProcessFG.get('standardOfferDocument'), offerData)
        "
        [disabled]="orderProcessDetails.sk_executor_action !== skExecutorAction.approve_offer"
        chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
        mode="basic"></p-fileUpload>
    </div>
    <div *ngIf="orderProcessFG.get('sapOfferId')" class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
      <label for="sap-offer-id" class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-label text-right-align">
        {{ 'overview.process-details.offer-id' | translate }}
      </label>
      <input id="sap-offer-id" formControlName="sapOfferId" pInputText type="text" readonly />
    </div>
  </div>

  <div
    class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 margin-align form-font-size action-button-section btn-section-left"
    *ngIf="isInternalUser">
    <button
      (click)="updateOrderProcess()"
      [disabled]="!(areAllSectionsAccepted$ | async) || disableSubmitOfferButton"
      class="view-btn-width"
      id="submit-std-offer-btn"
      label="{{ 'overview.process-details.standard-offer-button' | translate }}"
      pButton
      type="button"></button>

    <button
      (click)="updateOrderProcess(true, skExecutorAction.application_rejected)"
      [disabled]="isReadOnly || orderProcessDetails.sk_executor_action !== skExecutorAction.approve_offer"
      class="view-btn-width ml-1"
      id="reject-application-btn"
      label="{{ 'overview.process-details.application-reject-button' | translate }}"
      pButton
      type="button"></button>

    <button
      *ngIf="orderProcessDetails && showRequestChangeBtn"
      (click)="updateOrderProcess(true, skExecutorAction.request_update_application)"
      [disabled]="
        isReadOnly ||
        !(areAnySectionRejected$ | async) ||
        (areAnySectionUnreviewed$ | async) ||
        orderProcessDetails.sk_executor_action !== skExecutorAction.approve_offer
      "
      class="ml-1"
      id="request-change-btn"
      label="{{ 'overview.process-details.application-update-request-button' | translate }}"
      pButton
      type="button"></button>
  </div>

  <div class="standard-offer-row ui-g-12 form-font-size" *ngIf="orderData?.document?.length && showSection(sectionType.Order)">
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
      <div class="ui-g-6 field-label">{{ 'overview.process-details.order-title' | translate }}</div>
    </div>

    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 action-button-section">
      <button
        (click)="downloadDocument(orderData.document[0])"
        class="view-btn-width"
        id="order-download-btn"
        label="{{ 'view-button-label' | translate }}"
        pButton
        type="button"></button>
    </div>
  </div>

  <div *ngIf="!isReadOnly && isInternalUser" class="file-upload-section form-font-size">
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
      <input class="doc-submit-inputs" formControlName="orderDocument" pInputText type="text" />
    </div>
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
      <p-fileUpload
        #documentUploader
        (onSelect)="uploadDocument($event.files[0], docIdTypes.order, documentUploader, orderProcessFG.get('orderDocument'), orderData)"
        [disabled]="orderProcessDetails.sk_executor_action !== skExecutorAction.approve_order"
        chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
        mode="basic"></p-fileUpload>
    </div>
    <div *ngIf="orderProcessFG.get('sapOrderId')" class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
      <label for="sap-order-id" class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-label text-right-align">
        {{ 'overview.process-details.order-id' | translate }}
      </label>
      <input id="sap-order-id" formControlName="sapOrderId" pInputText type="text" readonly />
    </div>
  </div>

  <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 margin-align form-font-size action-button-section" *ngIf="isInternalUser">
    <button
      (click)="updateOrderProcess()"
      [disabled]="disableSubmitOrderButton"
      class="view-btn-width"
      id="submit-order-btn"
      label="{{ 'overview.process-details.order-button' | translate }}"
      pButton
      type="button"></button>
  </div>

  <div class="standard-offer-row ui-g-12 form-font-size" *ngIf="invoiceData?.document?.length && showSection(sectionType.Invoice)">
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
      <div class="ui-g-6 field-label">{{ 'overview.process-details.invoicing-title' | translate }}</div>
    </div>

    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 action-button-section">
      <button
        (click)="downloadDocument(invoiceData.document[0])"
        class="view-btn-width"
        id="invoice-download-btn"
        label="{{ 'view-button-label' | translate }}"
        pButton
        type="button"></button>
    </div>
  </div>

  <div *ngIf="!isReadOnly && isInternalUser" class="file-upload-section form-font-size">
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
      <input class="doc-submit-inputs" formControlName="invoiceDocument" pInputText type="text" />
    </div>
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
      <p-fileUpload
        #documentUploader
        (onSelect)="
          uploadDocument($event.files[0], docIdTypes.invoice, documentUploader, orderProcessFG.get('invoiceDocument'), invoiceData)
        "
        [disabled]="orderProcessDetails.sk_executor_action !== skExecutorAction.approve_invoice"
        chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
        mode="basic"></p-fileUpload>
    </div>
  </div>

  <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 form-font-size action-button-section" *ngIf="isInternalUser">
    <button
      (click)="updateOrderProcess()"
      [disabled]="disableSubmitInvoiceButton"
      class="view-btn-width"
      id="submit-invoice-btn"
      label="{{ 'overview.process-details.invoice-button' | translate }}"
      pButton
      type="button"></button>
  </div>
</form>

<div
  *ngIf="(isInstallationFlow || isConnectionFlow) && orderProcessDetails"
  class="order-process-container component-container application-section">
  <div *ngIf="!isConnectionFlow" class="margin-align">
    <div class="margin-header-align text-uppercase page-title">{{ 'overview.process-details.order-process-title' | translate }}</div>
  </div>

  <div class="standard-offer-row ui-g-12 form-font-size">
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 standard-offer-row-section">
      <div class="ui-g field-label">
        <b>
          {{ 'overview.process-details.current-status' | translate }} :
          {{ 'lookup.' + orderProcessesKey + '.options.' + orderProcessDetails[orderProcessesKey] + '.name' | translate }}
        </b>
      </div>
    </div>
  </div>
  <div
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 margin-align form-font-size flex-buttons"
    *ngIf="showAcceptRejectApplicationBtns && !isApplicationCompleted">
    <button
      (click)="updateOrderProcess()"
      [disabled]="!(areAllSectionsAccepted$ | async)"
      class="view-btn-width"
      id="accept-application-btn"
      label="{{ 'overview.process-details.application-accept-button' | translate }}"
      pButton
      type="button"></button>

    <button
      (click)="updateOrderProcess(true, skExecutorAction.application_rejected)"
      [disabled]="!(areAnySectionRejected$ | async)"
      class="view-btn-width ml-1"
      id="reject-application-btn"
      label="{{ 'overview.process-details.application-reject-button' | translate }}"
      pButton
      type="button"></button>

    <button
      *ngIf="showRequestChangeBtn && orderProcessDetails.sk_executor_action !== skExecutorAction.update_application"
      (click)="updateOrderProcess(true, skExecutorAction.request_update_application)"
      [disabled]="!(areAnySectionRejected$ | async)"
      class="ml-1"
      id="request-change-btn"
      label="{{ 'overview.process-details.application-update-request-button' | translate }}"
      pButton
      type="button"></button>
  </div>

  <!-- OFFER ACCEPTANCE BUTTONS FOR EXTERNAL USERS -->
  <div
    class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 margin-align form-font-size action-button-section standard-offer-buttons"
    *ngIf="isConnectionFlow && isBusinessPartner && orderProcessDetails?.sk_executor_action === skExecutorAction.accept_offer">
    <button
      (click)="updateOrderProcess(false, skExecutorAction.accept_offer)"
      [disabled]="orderProcessDetails.sk_executor_action !== skExecutorAction.accept_offer"
      class="view-btn-width mr-1"
      id="accept-std-offer-btn"
      label="{{ 'overview.process-details.offer-accept-button' | translate }}"
      pButton
      type="button"></button>
    <button
      *ngIf="showCorrectOfferButton"
      (click)="updateOrderProcess(true, skExecutorAction.correct_offer)"
      [disabled]="orderProcessDetails.sk_executor_action !== skExecutorAction.accept_offer"
      class="view-btn-width mr-1"
      id="correct-std-offer-btn"
      label="{{ 'overview.process-details.offer-correct-button' | translate }}"
      pButton
      type="button"></button>
    <button
      (click)="updateOrderProcess(true, skExecutorAction.reject_offer)"
      [disabled]="orderProcessDetails.sk_executor_action !== skExecutorAction.accept_offer"
      class="view-btn-width"
      id="reject-std-offer-btn"
      label="{{ 'overview.process-details.offer-reject-button' | translate }}"
      pButton
      type="button"></button>
  </div>

  <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 margin-align form-font-size action-button-section" *ngIf="isExternalUser">
    <button
      *ngIf="showRequestChangeBtn && orderProcessDetails.sk_executor_action === skExecutorAction.update_application && isApplicationOwner"
      [disabled]="!documentsFormValid || !isPersonalDataValid"
      (click)="updateOrderProcess(true, skExecutorAction.update_application)"
      class="view-btn-width ml-1"
      id="update-data-btn"
      label="{{ 'overview.process-details.update-application-button' | translate }}"
      pButton
      type="button"></button>
  </div>

  <div
    class="ui-g-12 margin-align form-font-size action-button-section chimney-sweeper-buttons"
    *ngIf="isChimneySweeper && orderProcessDetails.sk_executor_action === skExecutorAction.cs_accept_application">
    <div class="ui-g-6 chimney-sweeper-content">
      <button
        (click)="updateOrderProcess()"
        [disabled]="
          isReadOnly ||
          orderProcessDetails.chimney_sweeper_id !== technicianId ||
          !(areAllSectionsAccepted$ | async) ||
          (areAnySectionUnreviewed$ | async)
        "
        class="view-btn-width"
        id="approve-application-btn"
        label="{{ 'overview.process-details.approve-offer-btn' | translate }}"
        pButton
        type="button"></button>

      <button
        (click)="updateOrderProcess(true)"
        [disabled]="isReadOnly || orderProcessDetails.chimney_sweeper_id !== technicianId"
        class="view-btn-width"
        id="deny-application-btn"
        label="{{ 'overview.process-details.reject-offer-btn' | translate }}"
        pButton
        type="button"></button>

      <button
        (click)="updateOrderProcess(true, skExecutorAction.cs_request_update_application)"
        [disabled]="
          isReadOnly ||
          orderProcessDetails.chimney_sweeper_id !== technicianId ||
          !(areAnySectionRejected$ | async) ||
          (areAnySectionUnreviewed$ | async)
        "
        class="view-btn-width"
        id="deny-application-btn"
        label="{{ 'overview.process-details.application-update-request-button' | translate }}"
        pButton
        type="button"></button>
    </div>

    <div class="ui-g-6 chimney-sweeper-content">
      <p-dropdown
        [options]="chimneySweeperOptions"
        [(ngModel)]="chimneySweeper"
        [disabled]="orderProcessDetails.chimney_sweeper_id !== technicianId"
        id="chimney-sweeper"
        placeholder="-Select-"
        optionLabel="name"></p-dropdown>
      <button
        (click)="changeChimneySweeper()"
        [disabled]="!chimneySweeper?.chimney_sweeper_id"
        class="view-btn-width"
        id="change-chimney-sweeper-btn"
        label="{{ 'overview.process-details.reassign-request-btn' | translate }}"
        pButton
        type="button"></button>
    </div>
  </div>
</div>

<p-confirmDialog #offerAcceptanceDialog icon="pi pi-info-circle" styleClass="netz-confirm-dialog">
  <p-footer>
    <button (click)="offerAcceptanceDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
    <button (click)="offerAcceptanceDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
  </p-footer>
</p-confirmDialog>

<app-loader *ngIf="isLoading"></app-loader>
